import { createBackgroundLoaderContext } from "contexts";
import { MayTerm } from "models";

export const MayTermContext = createBackgroundLoaderContext<MayTerm>();
